export default "__VITE_PUBLIC_ASSET__ba1581f5__"